import { render, staticRenderFns } from "./RectangleResizeDragHandle.vue?vue&type=template&id=202a0970&scoped=true&"
import script from "./RectangleResizeDragHandle.vue?vue&type=script&lang=ts&"
export * from "./RectangleResizeDragHandle.vue?vue&type=script&lang=ts&"
import style0 from "./RectangleResizeDragHandle.vue?vue&type=style&index=0&id=202a0970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202a0970",
  null
  
)

export default component.exports